import StartApplicationDisclaimer from './StartApplicationDisclaimer';
export { StartApplicationDisclaimer };
export default StartApplicationDisclaimer;
